const radioHook = "[js-calculator-radio]";
const weightInputHook = "[js-calculator-weight]";
const priceInputHook = "[js-calculator-price]";
const buttonHook = "[js-calculator-button]";
const saleAlertHook = "[js-calculator-sale]";

class Calculator {
  constructor(element) {
    this.element = element;
    this.type = element.dataset.type || "goud";
    this.bid = {
      silver: 0,
      gold: 0,
    };
    this.totalPrice = {
      silver: 0,
      gold: 0,
    };
    this.saleActive = {
      silver: false,
      gold: false
    };
    this.saleAmount = {
      silver: 0,
      gold: 0
    }
    this.radios = element.querySelectorAll(radioHook);
    this.weight = element.querySelector(weightInputHook).value || 0;
    this.priceInput = element.querySelector(priceInputHook);
    this.weightInput = element.querySelector(weightInputHook);
    this.button = element.querySelector(buttonHook);
    this.weightLabel = element.querySelector('[js-weight-label]');
    this.saleAlert = element.querySelector(saleAlertHook)
    this.sale = element.dataset.sale == 'true' ? true : false;
    this.saleActiveData = {
      gold: element.dataset.goldActive || false,
      silver: element.dataset.silverActive || false
    }

    this.init();
  }

  async init() {
    const silverPrice = await this.getPrice("silver");
    const goldPrice = await this.getPrice("gold");

    this.bid = {
      gold: goldPrice,
      silver: silverPrice,
    };

    await this.setPrices();

    this.button.disabled = false;
    this.priceInput.disabled = false;
    this.weightInput.disabled = false;

    this.initRadios();

    this.priceInput.addEventListener("change", (e) => {
      this.updateWeight(e.currentTarget.value);
    });

    this.weightInput.addEventListener("change", (e) => {
      this.updatePrice(this.type);
    });

    this.element.addEventListener("submit", (e) => this.submitHandler(e))
  }

  submitHandler(event) {
    event.preventDefault();

    let type = '';
    let metal = '';
    let quantity = this.weightInput.value;

    this.radios.forEach(e => {
      if (e.checked) {
        type = e.value;
        metal = e.value == 'silver' ? 'Ag' : 'Au';
      }
    })

    window.location.href = `https://account.doijerkalff.nl/draft-order?quantity=${type == 'silver' ? quantity * 1000 : quantity}&quantity_type=g&metal=${metal}`;
  }

  updateSaleAmount(type) {
    if(this.saleAlert) {
      if (this.saleActive[type] && this.saleActiveData[type] == 'true') {
      const currentAmount = this.saleAmount[type];
        this.saleAlert.innerHTML = `Nog ${type == 'gold' ? `${currentAmount} gram` : `${(currentAmount / 1000).toFixed(0).replace('.', ',')} kilo`} beschikbaar!`;
      } else {
        this.saleAlert.innerHTML = 'Helaas, de voorraad is op.'
      }
    }
  }

  updateSale(res, type) {
    this.saleActive[type] = res.sale_active;
    this.saleAmount[type] = res.sale_quantity;

    this.updateSaleAmount(this.type);
  }

  async getPrices() {
    this.getPrice('gold')
    this.getPrice('silver')

    await this.updateSale(JSON.parse(localStorage.getItem('gold')), 'gold')
    await this.updateSale(JSON.parse(localStorage.getItem('silver')), 'silver')
  }

  async getPrice(type) {
    const json = JSON.parse(localStorage.getItem(type));
    this.updateSale(json, type)

    return this.sale ? json.sale_ask : json.ask;
  }

  initRadios() {
    this.radios.forEach((e) => {
      e.checked = e.value == this.type;
      e.disabled = false;
      e.addEventListener("change", (event) => {
        this.weightLabel.innerHTML = event.currentTarget.value == 'silver' ? 'kilo' : 'gram';
        this.updatePrice(event.currentTarget.value);
        this.updateSaleAmount(event.currentTarget.value);
        this.type = event.currentTarget.value;
      });
    });
  }

  async setPrices() {
    if (this.weight <= 0) this.resetForm();

    const prices = {
      gold: this.weight * this.bid.gold,
      silver: (this.weight * this.bid.silver) * 1000,
    };

    this.totalPrice = prices;
    this.priceInput.value = prices[this.type].toFixed(2);
  }

  updateWeight(price) {
    if (price <= 0) this.resetForm();
    const totalWeight = price / this.bid[this.type];

    this.weightInput.value = totalWeight.toFixed(2);
  }

  updatePrice(type) {
    const weight = this.weightInput.value;

    const prices = {
      gold: weight * this.bid.gold,
      silver: (weight * this.bid.silver) * 1000,
    };

    this.totalPrice = prices;
    this.priceInput.value = prices[type].toFixed(2);
  }

  resetForm() {
    this.weightInput.value = 0;
    this.priceInput.value = 0;
  }
}

export default Calculator;
